import { trackButtonClick, trackCustomEvent } from '../firebaseConfig';

// Custom hook for tracking button clicks
export const useButtonTracking = (sectionName: string) => {
  return (buttonName: string) => {
    trackButtonClick(buttonName, sectionName);
  };
};

// Custom hook for tracking any event
export const useCustomEventTracking = () => {
  return (eventName: string, eventParams: Record<string, any>) => {
    trackCustomEvent(eventName, eventParams);
  };
};

// Example usage:
// const trackButton = useButtonTracking('My Section');
// const handleClick = () => {
//   trackButton('My Button');
//   // other logic
// }; 